import React, { Fragment } from "react";
export  const attachmentscreen = (props) => {
  

    return (
        <Fragment>
      
        </Fragment>
        
    )
}


export default attachmentscreen;


